export function vetted() {

  return async ( dispatch, getState, api ) => {

    const { access, xeon, view } = getState()

    if ( access.sub.includes( "standard" ) || access.sub.includes( "basic" ) ) {
      dispatch( { type: "view.drugs.vetted", data: true } )
    }

    if ( access.sub.includes( "anonym" ) ) {
      if ( Object.values( xeon.drugs ).length >= 3 ) {
        dispatch( { type: "view.drugs.notify", data: "info_access_anonym" } )
        dispatch( { type: "view.drugs.vetted", data: false } )
      } else if ( view.drugs && view.drugs.vetted == false ) {
        dispatch( { type: "view.drugs.notify", data: "" } )
        dispatch( { type: "view.drugs.vetted", data: true } )
      }
    }

    return Promise.resolve()
  }

}